/* ============================================
   eg-navigation.js
   e.g. custom accordion navigation
   ============================================ */



(function () {
  'use strict';

  const STORAGE_KEY_DESKTOP = 'eg-nav-state-desktop';
  const STORAGE_KEY_MOBILE  = 'eg-nav-state-mobile';

  function loadState(key) {
    try {
      const raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveState(key, openHandles) {
    try {
      sessionStorage.setItem(key, JSON.stringify(openHandles));
    } catch (e) {}
  }

  function clearAllStates() {
    try {
      sessionStorage.removeItem(STORAGE_KEY_DESKTOP);
      sessionStorage.removeItem(STORAGE_KEY_MOBILE);
    } catch (e) {}
  }

  function getCurrentCollectionHandle() {
    const match = window.location.pathname.match(/\/collections\/([^\/\?#]+)/);
    return match ? match[1] : null;
  }

  function setAccordionState(trigger, panel, isOpen) {
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    const iconEl = trigger.querySelector('.eg-nav__icon');
    if (iconEl) iconEl.textContent = isOpen ? '−' : '+';
    if (isOpen) {
      panel.classList.add('eg-nav__panel--open');
    } else {
      panel.classList.remove('eg-nav__panel--open');
    }
  }

  function applyCurrentDot(navEl) {
    const currentHandle = getCurrentCollectionHandle();
    if (!currentHandle || !navEl) return;
    navEl.querySelectorAll('.eg-nav__sublink').forEach(function (link) {
      const href = link.getAttribute('href') || '';
      if (href.includes('/' + currentHandle)) {
        link.classList.add('eg-nav__sublink--current');
      }
    });
  }

  function initAccordion(navEl, storageKey) {
    if (!navEl) return;
    if (navEl.dataset.egInitialized) return;
    navEl.dataset.egInitialized = 'true';

    const triggers = navEl.querySelectorAll('.eg-nav__trigger');
    const currentHandle = getCurrentCollectionHandle();
    let openHandles = loadState(storageKey);
    const hasStoredState = openHandles.length > 0;

    // 現在ページの親カテゴリーを自動展開
    if (currentHandle) {
      triggers.forEach(function (trigger) {
        const panelId = trigger.getAttribute('aria-controls');
        const panel = document.getElementById(panelId);
        if (!panel) return;
        panel.querySelectorAll('.eg-nav__sublink').forEach(function (link) {
          const href = link.getAttribute('href') || '';
          if (href.includes('/' + currentHandle)) {
            const handle = trigger.dataset.handle;
            if (handle && !openHandles.includes(handle)) {
              openHandles.push(handle);
            }
          }
        });
      });
    }

    triggers.forEach(function (trigger) {
      const handle = trigger.dataset.handle;
      const panelId = trigger.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      if (!panel) return;

      let isOpen;
      if (hasStoredState) {
        isOpen = openHandles.includes(handle);
      } else {
        isOpen = trigger.dataset.defaultOpen === 'true' || openHandles.includes(handle);
      }

      setAccordionState(trigger, panel, isOpen);

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        const currentlyOpen = trigger.getAttribute('aria-expanded') === 'true';
        const newState = !currentlyOpen;
        setAccordionState(trigger, panel, newState);

        let handles = loadState(storageKey);
        if (newState) {
          if (!handles.includes(handle)) handles.push(handle);
        } else {
          handles = handles.filter(function (h) { return h !== handle; });
        }
        saveState(storageKey, handles);
      });
    });

    applyCurrentDot(navEl);
  }

  function initDrawer() {
    const drawer = document.getElementById('eg-drawer');
    const overlay = document.getElementById('eg-drawer-overlay');
    const openBtn = document.getElementById('eg-drawer-open');


    if (!drawer || !openBtn) return;

    function openDrawer() {
      const header = document.querySelector('.section-header');
      if (header) {
        const top = header.getBoundingClientRect().bottom;
        drawer.style.top = top + 'px';
        drawer.style.height = 'calc(100dvh - ' + top + 'px)';
        if (overlay) {
          overlay.style.top = top + 'px';
          overlay.style.height = 'calc(100vh - ' + top + 'px)';
        }
      }
      drawer.classList.add('eg-drawer--open');
      if (overlay) overlay.classList.add('eg-drawer-overlay--open');
      document.body.style.overflow = 'hidden';

      openBtn.setAttribute('aria-label', 'メニューを閉じる');
      openBtn.classList.add('eg-drawer-open--active');

      requestAnimationFrame(function () {
        const mobileNav = drawer.querySelector('.eg-nav--mobile');
        initAccordion(mobileNav, STORAGE_KEY_MOBILE);
      });
    }

    function closeDrawer() {
      drawer.classList.remove('eg-drawer--open');
      if (overlay) overlay.classList.remove('eg-drawer-overlay--open');
      document.body.style.overflow = '';
      openBtn.setAttribute('aria-label', 'メニューを開く');
      openBtn.classList.remove('eg-drawer-open--active');
    }

    openBtn.addEventListener('click', function () {
      const isOpen = drawer.classList.contains('eg-drawer--open');
      if (isOpen) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });


    if (overlay) overlay.addEventListener('click', closeDrawer);
  }

  function initLogoReset() {
    const logoLinks = document.querySelectorAll('.header__heading-link, .header__heading a');
    logoLinks.forEach(function (logoLink) {
      logoLink.addEventListener('click', function () {
        clearAllStates();
      });
    });
  }

    function init() {
    const desktopNav = document.querySelector('.eg-nav--desktop');
    initAccordion(desktopNav, STORAGE_KEY_DESKTOP);
    initDrawer();
    initLogoReset();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }


})();
